// libs
import React from 'react';

// types
import { Theme } from '@nykaa/ui-components/themes/types';

//hook
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';

// styles
import { AddToWishlistText, WishlistContainer } from './styles';

// icons
import HeartIcon from '@nykaa/ui-components/Icons/heart-plus';
import HeartFilledIcon from '@nykaa/ui-components/Icons/heart-filled';
import { SpotLoader } from '@nykaa/ui-components/Loader';

interface IWishlist {
  isWishListProduct: boolean;
  handleClick: () => void;
  isUpdating: boolean;
}

const WISHLIST_ICON_SIZE = 24;

function WishlistButton({ isWishListProduct, handleClick, isUpdating }: IWishlist) {
  const WISHLIST_BUTTON_TEXT = isWishListProduct ? 'Added to Wishlist' : 'Add to Wishlist';
  const theme: Theme = useTheme();

  return (
    <WishlistContainer onClick={handleClick}>
      {isUpdating ? (
        <SpotLoader />
      ) : (
        <>
          {isWishListProduct ? (
            <HeartFilledIcon color={theme.colors.secondary} size={`${WISHLIST_ICON_SIZE}px`} />
          ) : (
            <HeartIcon color={theme.colors.primary} size={`${WISHLIST_ICON_SIZE}px`} />
          )}
          <AddToWishlistText>{WISHLIST_BUTTON_TEXT}</AddToWishlistText>
        </>
      )}
    </WishlistContainer>
  );
}

export default WishlistButton;
